export default __webpack_public_path__ + "static/media/vr_1.f465362e.jpg";